module.exports = new __parcel__URL__("monday-logomark.aa2f5c1e.svg").toString();